import PropTypes from 'prop-types';
import {
  Sources,
  AppointmentDateTypes,
  PatientInsuranceTypeOrMedflex,
  RequestAppointmentActions,
  AppointmentReasons,
  AppointmentTypes,
  DiagnosisRequestTypes,
  DocumentsDelivery,
  RequestTypes,
  UserTypes,
  RequestStatus,
} from '@medflex/shared-types';

const AssigneePropType = PropTypes.shape({
  type: PropTypes.oneOf([UserTypes.PHYSICIAN, UserTypes.STAFF]),
  id: PropTypes.string,
  attributes: PropTypes.shape({
    avatar: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    title: PropTypes.string,
  }),
});

const InquiryPropType = PropTypes.shape({
  id: PropTypes.string,
  assignee: AssigneePropType,
  status: PropTypes.oneOf(Object.values(RequestStatus)),
  statusChanged: PropTypes.shape({
    updatedAt: PropTypes.string,
    userId: PropTypes.string,
    user: {
      title: PropTypes.string,
      gender: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    },
  }),
  source: PropTypes.oneOf(Object.values(Sources)),
  requestType: PropTypes.oneOf(Object.values(RequestTypes)),
  phoneTranscript: PropTypes.string,
  patientInsuranceTypeOrMedflex: PropTypes.oneOf(Object.values(PatientInsuranceTypeOrMedflex)),
  appointmentAction: PropTypes.oneOf(Object.values(RequestAppointmentActions)),
  appointmentReason: PropTypes.oneOf(Object.values(AppointmentReasons)),
  appointmentType: PropTypes.oneOf(Object.values(AppointmentTypes)),
  symptomsDescription: PropTypes.string,
  symptomsDuration: PropTypes.string,
  existingAppointmentDateTime: PropTypes.string,
  appointmentDateType: PropTypes.oneOf(Object.values(AppointmentDateTypes)),
  appointmentAvailability: PropTypes.shape({}),
  diagnosisDetails: PropTypes.string,
  diagnosisRequestType: PropTypes.oneOf(Object.values(DiagnosisRequestTypes)),
  afterCareDetails: PropTypes.string,
  followUpPrescription: PropTypes.string,
  generalInquiryDetails: PropTypes.string,
  files: PropTypes.arrayOf(PropTypes.shape({})),
  referralReason: PropTypes.string,
  documentsDelivery: PropTypes.oneOf(Object.values(DocumentsDelivery)),
  additionalComment: PropTypes.string,
});

export { AssigneePropType, InquiryPropType };
